import { Box } from "@mui/material";
import { useState } from "react";
import { SystemLogDto } from "../../../api";
import { SystemLogGrid } from "./SystemLogGrid";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { dark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { useUserContext } from "../../UserContext";

export const SystemLogTabPage = () => {
  const ctx = useUserContext();
  const [log, setLog] = useState("");

  const onSystemLogSelected = (dto: SystemLogDto | null) => {
    let value = dto?.log ?? "";
    if (value && value.startsWith("{")) {
      try {
        value = JSON.stringify(JSON.parse(value), null, 2);
      } catch {
        // DO NOTHING
      }
    }
    setLog(value);
  };

  return (
    <Box maxWidth="700px">
      <SystemLogGrid onRowSelected={onSystemLogSelected} />
      <Box sx={{ p: 1 }} />
      {log && (
        <Box>
          <SyntaxHighlighter language="json" style={ctx.themeName.indexOf("dark") >= 0 ? dark : docco}>
            {log}
          </SyntaxHighlighter>
        </Box>
      )}
    </Box>
  );
};
